"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureInfoModal = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var common_1 = require("../../common");
var react_intl_1 = require("react-intl");
var mobx_react_1 = require("mobx-react");
var SignatureInfoModel_1 = require("../../../models/SignatureInfoModel");
var SignatureInfoItem_1 = require("./SignatureInfoItem");
var signature_info_accordion_1 = require("./signature-info-accordion");
var SignatureInfoModalStyles_1 = require("./SignatureInfoModalStyles");
var messageLink_1 = require("../../../utils/messageLink");
var CryptoContext_1 = require("../../../context/CryptoContext");
exports.SignatureInfoModal = mobx_react_1.observer(function (props) {
    var isView = props.isView, onClose = props.onClose, signatureStatus = props.signatureStatus;
    var _a = react_1.useContext(CryptoContext_1.CryptoContext), fileTitle = _a.fileTitle, fileTitleWithExtension = _a.fileTitleWithExtension, getSignatureInfo = _a.getSignatureInfo, downloadSignature = _a.downloadSignature, deleteSignature = _a.deleteSignature, onSuccess = _a.onSuccess;
    var signatureInfoClasses = SignatureInfoModalStyles_1.useSignatureInfoModalStyles({ signatureStatus: signatureStatus });
    var model = react_1.useMemo(function () { return new SignatureInfoModel_1.SignatureInfoListModel(fileTitleWithExtension, deleteSignature, downloadSignature); }, [fileTitleWithExtension, deleteSignature, downloadSignature]);
    var linkClasses = messageLink_1.useLinkStyles();
    react_1.useEffect(function () {
        getSignatureInfo().then(function (signatureInfoList) { return model.load(signatureInfoList); });
    }, [signatureStatus]);
    var handleSuccess = function () {
        onSuccess && onSuccess();
        onClose();
    };
    return (react_1.default.createElement(core_1.Dialog, { maxWidth: "sm", fullWidth: true, open: true, scroll: "body", id: "signature-info-modal" },
        react_1.default.createElement(core_1.Box, { padding: 8 },
            react_1.default.createElement(core_1.Grid, { container: true, direction: "column", spacing: 4 },
                react_1.default.createElement(core_1.Grid, { container: true, item: true, justify: "space-between", alignItems: "center", wrap: "nowrap" },
                    react_1.default.createElement(core_1.Grid, { container: true, item: true, spacing: 3, alignItems: "center", wrap: "nowrap" },
                        react_1.default.createElement(common_1.Title, { text: fileTitle }),
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(common_1.StatusBar, { className: signatureInfoClasses.bar },
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: signatureStatus })))),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.IconButton, { onClick: onClose },
                            react_1.default.createElement(icons_1.Close, null)))),
                react_1.default.createElement(core_1.Grid, { container: true, item: true, direction: "column", spacing: 1 },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Link, { component: "button", onClick: function () { return model.download(false); }, className: linkClasses.link },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "download" }))),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Link, { component: "button", onClick: function () { return model.download(true); }, className: linkClasses.link },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "downloadWithFile" }))),
                    !isView && (react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Link, { component: "button", onClick: function () { return model.delete(handleSuccess); }, className: linkClasses.link, id: "delete-button" },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "delete" }))))),
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(common_1.Separator, null)),
                model.signatureInfoList.length && model.isSingleSignature ? (react_1.default.createElement(SignatureInfoItem_1.SignatureInfoItem, { signatureInfo: model.signatureInfoList[0], isSingleItem: true })) : (react_1.default.createElement(signature_info_accordion_1.SignatureInfoAccordion, { signatureInfoList: model.signatureInfoList }))))));
});
